import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  createBusinessButton: '+ Add Business',
  createPersonButton: '+ Add Person',
})
